import { globals } from './';
let semaphore = false;
let httpcon;
export async function getCSRF(authentication) {
    var _a, _b;
    if ((_b = (_a = authentication) === null || _a === void 0 ? void 0 : _a.csrf) === null || _b === void 0 ? void 0 : _b.token) {
        return getCSRFTokenString(authentication.csrf);
    }
    else {
        const { csrfTokenString } = await getHttpcon();
        return csrfTokenString;
    }
}
export async function getDeviceId(authentication) {
    if (globals.window.location.host === 'mp3localhost.amazon.com:4000') {
        const { deviceId } = await getHttpcon();
        return deviceId || authentication.sessionId;
    }
    return authentication.deviceId;
}
export async function getHttpcon() {
    if (!httpcon && !semaphore) {
        const response = await globals.fetch('/horizonte/sample/httpcon', {
            method: 'get',
        });
        const responseJson = await response.json();
        const { csrf_token, csrf_ts, csrf_rnd } = responseJson.CSRFTokenConfig;
        const { deviceId } = responseJson;
        const csrf = {
            token: csrf_token,
            ts: csrf_ts,
            rnd: csrf_rnd,
        };
        httpcon = {
            csrfTokenString: getCSRFTokenString(csrf),
            deviceId,
        };
    }
    semaphore = true;
    return httpcon;
}
function getCSRFTokenString(csrf) {
    return `{
            "interface": "CSRFInterface.v1_0.CSRFHeaderElement",
            "token": "${csrf.token}",
            "timestamp": "${csrf.ts}",
            "rndNonce": "${csrf.rnd}"
        }`.replace(/\s/g, '');
}
